module.exports = __webpack_public_path__ + "img/oakv2.d65a44a2.png";